import { createApi } from '@reduxjs/toolkit/query/react';
import { AimAttachment, OpportunityAttachmentPostParams } from '../../models/AttachmentModels';
import { attachmentEndpoints } from '../endpoints/attachmentEndpoints';
import { AxiosProgressEvent } from 'axios';
import { axiosBaseQuery } from './baseQueries/axiosBaseQuery';
import { AIM_SERVICE } from '../../envUtils';

const AimApiQueryCreator = () => {
  let getToken: () => Promise<string> | string = () => '';
  const setTokenGetter = (getter: () => Promise<string> | string) => {
    getToken = getter;
  };
  const api = createApi({
    reducerPath: 'axiosApi',
    baseQuery: axiosBaseQuery({
      baseUrl: `${AIM_SERVICE}`,
      prepareHeaders: async (headers) => {
        const token = await getToken();
        headers['Authorization'] = `Bearer ${token}`;
        return headers;
      }
    }),
    tagTypes: ['AimAttachment'],
    endpoints: (builder) => ({
      addOpportunityAttachments: builder.mutation<AimAttachment[], OpportunityAttachmentPostParams>({
        query: ({ aimOpportunity, attachments, onUploadProgress }) => ({
          url: attachmentEndpoints.addOpportunityAttachments({
            aimOpportunity: aimOpportunity,
            attachments: attachments
          }),
          method: 'POST',
          data: attachments,
          onUploadProgress: onUploadProgress as ((progressEvent: AxiosProgressEvent) => void) | undefined
        }),
        invalidatesTags: ['AimAttachment']
      })
    })
  });
  return { hooks: api, setTokenGetter };
};

/**
 * An RTK Query service for Axios-based attachment uploads in the AIM platform, using a custom `axiosBaseQuery` that supports file-upload progress callbacks, paired with automatic Bearer-token injection.
 */
export const AxiosService = AimApiQueryCreator();
export const { useAddOpportunityAttachmentsMutation } = AxiosService.hooks;
